import deleteData from "../services/deleteData";
import fetchData from "../services/fetchData";
import patchData from "../services/patchData";
import postData from "../services/postData";

const handleFetchBusinesses = async ({ page, limit }: any) => {
  const uri = `v1/businesses?page=${page}&limit=${limit}`;
  const response = fetchData({ uri });
  return response;
};

const handleCreateBusiness = async (data: any) => {
  const uri = `v1/businesses`;
  const response = postData({ data, uri });
  return response;
};

const handleUpdateBusiness = async ({ _id, data }: any) => {
  const uri = `v1/businesses/${_id}`;
  const response = patchData({ data, uri });
  return response;
};


const handleFetchBusinessCount = async ({ status }: any) => {
  const uri = `v1/businesses/count/all?status=${status}`;
  const response = fetchData({ uri });
  return response;
};


const handleDeleteBusiness = async (data: any) => {
  const uri = `v1/businesses`;
  const response = deleteData({ data, uri });
  return response;
};

export {
  handleFetchBusinesses,
  handleCreateBusiness,
  handleUpdateBusiness,
  handleDeleteBusiness,
  handleFetchBusinessCount
};
